import { render, staticRenderFns } from "./MultiSelectTabs.component.vue?vue&type=template&id=926a0acc&scoped=true&"
import script from "./MultiSelectTabs.component.vue?vue&type=script&lang=js&"
export * from "./MultiSelectTabs.component.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelectTabs.component.vue?vue&type=style&index=0&id=926a0acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926a0acc",
  null
  
)

export default component.exports